module.exports = __webpack_public_path__ + "media/side_menu_icons/wizard_track-8916ec0f.png";